module.exports = __webpack_public_path__ + "static/img/17-17.23ff1579.jpeg";